import React from "react"

export const SourcesGutHeart = () => {

return(
<div>
Journal of Human Hypertension (2022) 36:952–959; https://doi.org/10.1038/s41371-022-00698-6<br />
David LA, Maurice CF, et al.
Diet rapidly and reproducibly alters the human gut microbiome. Nature.
2014;505:559–63.<br />
</div>
)
}